module.exports = __webpack_public_path__ + "img/chinesecompany113.e2d473cd.png";